import React from 'react'
import styled, {keyframes} from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const FadeInContainer = styled.div`
  animation: ${fadeIn} 0.2s linear 0.2s;
  opacity: 0;
  animation-fill-mode: forwards;
`;

export default FadeInContainer



// WEBPACK FOOTER //
// ./src/components/FadeIn.js